module.exports = __webpack_public_path__ + "img/3.625c0e8d.png";